// BarChart.jsx
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip} from 'chart.js';
import {Bar} from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BarChart = ({data}) => {
  const chartData = {
    labels: ['IVF', 'IUI', 'OI'],
    datasets: [
      {
        label: 'Positive',
        backgroundColor: 'rgba(40, 167, 69, 0.8)',
        borderColor: '#28a745',
        borderWidth: 1,
        data: [data.ivf.ivf_positive_count, data.iui.iui_positive_count, data.oi.oi_positive_count]
      },
      {
        label: 'Negative',
        backgroundColor: 'rgba(220, 53, 69, 0.8)',
        borderColor: '#dc3545',
        borderWidth: 1,
        data: [data.ivf.ivf_negative_count, data.iui.iui_negative_count, data.oi.oi_negative_count]
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 15
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0,0,0,0.8)',
        bodyFont: {size: 14},
        titleFont: {size: 16}
      }
    },
    scales: {
      x: {
        grid: {display: false},
        title: {
          display: true,
          text: 'Treatment Type',
          font: {size: 14}
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Numbers',
          font: {size: 14}
        }
      }
    }
  };

  return <Bar data={chartData} options={options} />;
};

export default BarChart;
